import constants from '@/app-configs/constants'

export default [
  {
    path: '/debtors/list',
    name: 'debtors-list',
    component: () => import('@/views/debtor/debtors-list/DebtorsList.vue'),
    meta: {
      pageTitle: 'DEBTIA_DEBTORS',
      breadcrumb: [
        {
          text: 'DEBTIA_DEBTORS',
          active: true,
        },
      ],
      action: constants.action.permissionLogin,
      resource: constants.resource.user,
      category: 'debtor',
    },
  },
  {
    path: '/debtors/edit/:id',
    name: 'debtor-edit',
    component: () => import('@/views/debtor/debtor-edit/DebtorEdit.vue'),
    meta: {
      action: constants.action.permissionLogin,
      resource: constants.resource.user,
      category: 'debtor',
    },
  },
  {
    path: '/debtors/add',
    name: 'debtors-add',
    component: () => import('@/views/debtor/debtors-add/DebtorAdd.vue'),
    meta: {
      title: 'Add Debtor',
      action: constants.action.permissionLogin,
      resource: constants.resource.user,
      category: 'debtor',
    },
  },
]
